/** @jsxImportSource @emotion/react */
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalBtnGroup, SubTitleGroup, SubTitleLayout } from 'components/layouts/ContentLayout';
import { useLoading } from 'components/process/Loading';
import { useMessageBar } from 'hooks/useMessageBar';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { IconButton } from 'components/buttons/IconSVG';
import { tb } from 'components/layouts/Table';
import useSessionStore from 'stores/useSessionStore';
import _ from 'lodash';
import { useCommonModal } from 'hooks/useCommonModal';
import { DefaultProps } from 'pages/md/invest/MdIvesCmpuRegPage';
import IvesInqPopup from '../../../popup/IvesInqPopup';

const IvesAtcIspt = ({ elmPrjId }: DefaultProps) => {
  const { t } = useTranslation();
  const { isLoading } = useLoading();
  const { openMessageBar } = useMessageBar();
  const { openCommonModal } = useCommonModal();

  const [rowData, setRowData] = useState([]);
  const [isOpenAddPopup, setIsOpenAddPopup] = useState<boolean>(false);

  const layoutDefinition = [
    { title: t('setup.label.적용여부', '적용여부'), width: '100' },
    { title: t('setup.label.공정', '공정'), width: '' },
    { title: t('setup.label.설비군', '설비군'), width: '' },
    { title: t('setup.label.투자항목', '투자항목'), width: '' },
    { title: t('setup.label.셀 구분', '셀 구분'), width: '' },
    { title: t('setup.label.설비대수', '설비대수'), width: '' },
    { title: t('setup.label.단가', '단가'), width: '' },
    { title: t('setup.label.점검대상', '점검대상'), width: '' },
    { title: t('setup.label.점검항목', '점검항목'), width: '' },
    { title: t('setup.label.판단근거', '판단근거'), width: '' },
  ];

  const initCodes = () => {
    //
  };

  const btnAdd = () => {
    setIsOpenAddPopup(true);
  };

  const btnDel = () => {
    //
  };

  useEffect(() => {
    initCodes();
  }, []);

  return (
    <>
      <SubTitleLayout>
        <SubTitleGroup>
          <h3>{t('setup.label.투자항목 점검', '투자항목 점검')}</h3>
        </SubTitleGroup>
        <GlobalBtnGroup>
          <Button css={IconButton.button} className="icoNone ok" onClick={btnAdd}>
            {t('com.label.투자항목 추가', '투자항목 추가')}
          </Button>
          <Button css={IconButton.button} className="delRow" onClick={btnDel}>
            {t('com.label.행삭제', '행삭제')}
          </Button>
          <Button
            css={IconButton.button}
            className="save"
            disabled={isLoading}
            onClick={(e) => null}
          >
            {t('com.label.저장', '저장')}
          </Button>
        </GlobalBtnGroup>
      </SubTitleLayout>
      <TableContainer css={tb.tableCol}>
        <Table>
          <TableHead>
            <TableRow>
              {layoutDefinition.map((item, idx) => {
                return (
                  <TableCell key={idx} width={item.width}>
                    {item.title}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowData.map((item, idx) => {
              return (
                <TableRow key={idx}>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {isOpenAddPopup && (
        <IvesInqPopup open={isOpenAddPopup} close={() => setIsOpenAddPopup(false)} />
      )}
    </>
  );
};

export default IvesAtcIspt;
